export const buildConfirmAppointmentParams = ({ turn, patient, auth }) => ({
	clinica: turn.clinica,
	direccionClinica: turn.direccion,
	idEspecialidad: turn.idEspecialidad,
	nombreEspecialidad: turn.nombreEspecialidad,
	idProfesional: turn.idProfesional,
	nombreProfesional: turn.nombreProfesional,
	idObraSocial: patient.idObraSocial,
	coberturaMedica: patient.coberturaMedica,
	plan: patient.planLineaCartilla,
	idPlan: patient.idPlan,
	idPaciente: patient.idPaciente,
	idSistema: '',
	fechaHora: turn.fechaTurnoDateTime,
	nroCobertura: patient.nroCobertura,
	nroAfiliado: patient.nroAfiliado,
	nombreCompletoPaciente: patient.nombreApellido,
	nombrePaciente: patient.nombres,
	nroDocumento: patient.numeroDocumento,
	esVideoconsulta: false,
	idTurno: turn.idTurno,
	Mail: auth.email,
	durationMinutes: turn.durationMinutes,
})
